import { useEffect } from 'react'
import { isHttpErrorResponseModel } from '../../../../apiService/models/HttpErrorResponseModel'
import IInstallationShop from '../../models/IInstallationShop'
import IInstallationShopVehicle from '../../models/IInstallationShopVehicle'
import fetchTimeslots from './fetchTimeslots'

/**
 * Checks if shop have timeslots for this vehicle.
 * Remove installation if don't
 */
const useValidateShopTimeslotsForItemVehicle = (
  installationShop: IInstallationShop | null,
  vehicle: IInstallationShopVehicle,
  skuETA: string | null,
  onRemoveFromCart: () => void,
) => {
  useEffect(() => {
    const validateShopTimeslots = async () => {
      if (installationShop && installationShop.isSelected && skuETA) {
        const shopTimeslots = await fetchTimeslots(installationShop.shopId,
          installationShop.partnerId,
          vehicle.partnerMakeId,
          skuETA,
          vehicle.make)
        if (isHttpErrorResponseModel(shopTimeslots)) {
          return
        }
        if (shopTimeslots.length === 0) {
          onRemoveFromCart()
        }
      }
    }

    validateShopTimeslots()
  }, [installationShop, onRemoveFromCart, skuETA, vehicle.make, vehicle.partnerMakeId])
}

export default useValidateShopTimeslotsForItemVehicle
